import React from "react";
import Dashboard from "../../Admin/dashboard/Dashboard";

const AdminPanelScreen = () => {
    return <Dashboard />;
};

export default AdminPanelScreen;
